<template>
    <form class="is-d-flex is-align-center">
        <div class="search-wrapper">
            <DelayedInput 
                id="mainAutocomplete"
                data-behavior="vue-search-app__autocomplete-input"
                v-model="searchTerm" 
                type="search" 
                placeholder="Search for conditions, groups and more..." 
                autocomplete="off" 
                aria-label="Search" 
                @click="activateSearch"
                />
            <button aria-label="search" @click="activateSearch"></button>
        </div>
    </form>
</template>

<script>
    import $ from "webpack-zepto";
    import axios from 'axios';
    import DelayedInput from "./DelayedInput";    

    const autocompleteInputSeletor = "[data-behavior='vue-search-app__autocomplete-input']";

    export default {
        name: "Autocomplete",
        components: {
          DelayedInput,
        },          
        data: function () {
            return {
                autoComplete: undefined,
            }
        },
        computed: {
            searchTerm: {
                get() {
                    return this.$store.state.searchTerm;
                },
                set(value) {
                    this.$store.commit('setSearchTerm', value);
                }
            },            
        },
        methods: {
            activateSearch(e) {
                $(document).trigger('SearchAppActivated', [e]);
            },           
        },
        mounted() {
            let app = this;
            
            this.autoComplete = new autoComplete({ // eslint-disable-line no-undef
                selector: autocompleteInputSeletor,
                source(term, suggest) {
                    axios.get(`/Umbraco/Api/SearchApi/Autocomplete?term=${term}`)
                        .then((response) => {
                            suggest(response.data);
                        })
                        .catch(function(error){ // eslint-disable-line no-unused-vars
                            suggest([])
                        });
                },
                onSelect(e, term, item) { // eslint-disable-line no-unused-vars
                    app.$store.commit('setSearchTerm', term);                    
                }
            });
        },
        beforeDestroy() {
            this.autoComplete.destroy();
        }
    }
</script>